<template>
    <div class="step-template step-3">
        <div :class="`text-wrapper no-app step-${ this.appStep }`">
            <div class="tablet-tables">
                <DataTable1/>
                <DataTable2/>
            </div>
            <div class="data-1">
                <h2>Vergleichbare Ergebnisse wie eine pharmakologische Intervention</h2>
                <div class="table-1">
                    <DataTable1/>
                </div>
                <p class="text"><strong>Methodik</strong></p>
                <ul class="text">
                    <li>Vitadio vs. retrospektive intraindividuelle Kontrollgruppe</li>
                    <li>n= 60, 55 % Männer, Durchschnittsalter 57</li>
                </ul>
            </div>
            <div class="data-2">
                <h2>Gleiche bis übertreffende Ergebnisse im Vergleich zu einer Einzeltherapie</h2>
                <p class="capital">Randomisierte kontrollierte Studie</p>

                <div class="table-2">
                    <DataTable2/>
                </div>
                
                <div>
                    <p class="text"><strong>Kontrollgruppe</strong></p>
                    <ul class="text">
                        <li>5 Einzelberatungen</li>
                        <li>Online-Tagebuch</li>
                        <li>Ansprechpartner:in nach Bedarf</li>
                    </ul>
                </div>

                <div>
                    <p class="text"><strong>Population</strong></p>
                    <ul class="text">
                        <li>n= 100, 30 % Männer</li>
                        <li>Durchschnittsalter 43 Jahre</li>
                        <li>BMI: 40 kg/m²</li>
                    </ul>
                </div>
            </div>
            <v-button
                variant="primary"
                color="green"
                label="Überzeugen Sie sich selbst"
                size="lg"
                @onClick="actualStep()"
                >
            </v-button>
        </div>
    </div>
</template>

<script>
import DataTable1 from '../DataTable1.vue'
import DataTable2 from '../DataTable2.vue'

export default {
    components: {
        DataTable1,
        DataTable2
    },

    props: {},
    data(){
        return {
            appStep: 3
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}

</script>
